import React from 'react';
import { Text, View, StyleSheet, TouchableOpacity, Dimensions, TouchableWithoutFeedback } from 'react-native';
import {
  Icon,
  Heading,
  HeadingTypes,
} from '../../components';
import Theme from '../../theme';
import { CheckBox } from '../../ui';
import { ChevronRightIcon } from './Icons';
const width = Dimensions.get('window').width;
const isMobile = width <= 550;
import { scaleText, defaultScale } from '../../utils/scaling';

const styles = StyleSheet.create({
  formHeader: {
    paddingVertical: defaultScale(5),
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Theme.WHITE,
    justifyContent: 'space-evenly'
  },
  formHeaderBorderBottom: {
    borderBottomWidth: 0.5,
    borderBottomColor: Theme.GREY_MEDIUM_LIGHT,
  },
  formTitle: {
    ...Theme.textStyle.bodyCopyBold,
    paddingVertical: defaultScale(15),
    color: Theme.GREY_DARK_MEDIUM,
    width: isMobile ? '33%' : '20%',
  },
  icon: {
    marginLeft: isMobile ? '5%' : '5%',
  },
  text: {
    marginLeft: isMobile ? '15%' : '45%',
    fontSize: scaleText(10),
    flexDirection: 'row',
  },
  checkBox: {
    fontFamily: Theme.Custom800,
    fontSize: 16,
    fontWeight: "bold",
  }
});

const AccordionShoppingHeader = ({
  index,
  section,
  isActive,
  setActiveIndex,
  isChecked,
  toggleSelection,
  isShoppingList,
  numberOfMealsSelected,
  onPress = () => { },
}) => (
    <TouchableOpacity
      onPress={() => {
        if (isActive) {
          setActiveIndex(false);
        } else {
          setActiveIndex(index);
        }
        onPress();
      }}
      style={[
        styles.formHeader,
        (section.isLast && !isActive) && styles.formHeaderBorderBottom]}>
        <CheckBox
          size={20}
          onPress={toggleSelection}
          isActive={isChecked}
          iconStyle={styles.checkBox}
          isShoppingList={isShoppingList}
          halfSelect={numberOfMealsSelected === 5 ? false : true}
        />

      <Heading
        title={section.title}
        style={styles.formTitle}
        headingType={HeadingTypes.HEADING_TWO}
      />
      <Text style={styles.text}>
        {numberOfMealsSelected} meals selected
    </Text>
      <Icon
        size={25}
        color={Theme.GREY_DARK_MEDIUM}
        style={styles.icon}
        name={isActive ? 'ios-arrow-up' : 'ios-arrow-down'}
      />
    </TouchableOpacity>
  );

export default AccordionShoppingHeader;
